module.exports = __webpack_public_path__ + "img/3-first_section.656e9edd.png";